<template>
  <DefaultLayout>
    <div class="page-header">
      <h1>Pagos Personalizados</h1>
      <p class="subtitle">Gestiona cobros manuales a tenants</p>
    </div>

    <Card>
      <template #content>
        <DataTable :value="payments" :loading="loading" responsiveLayout="scroll">
          <Column field="tenant_id" header="Tenant" />
          <Column field="amount" header="Monto">
            <template #body="{ data }">
              ${{ (data.amount / 100).toLocaleString('es-CO') }} COP
            </template>
          </Column>
          <Column field="description" header="Descripción" />
          <Column field="status" header="Estado">
            <template #body="{ data }">
              <Tag :severity="data.status === 'paid' ? 'success' : 'warning'" :value="data.status" />
            </template>
          </Column>
          <Column field="created_at" header="Fecha">
            <template #body="{ data }">
              {{ new Date(data.created_at).toLocaleDateString('es-CO') }}
            </template>
          </Column>
        </DataTable>
        <p v-if="!loading && payments.length === 0" class="empty-msg">
          No hay pagos personalizados registrados.
        </p>
      </template>
    </Card>
  </DefaultLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import DefaultLayout from '../../components/layout/DefaultLayout.vue';
import Card from 'primevue/card';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';

const payments = ref([]);
const loading = ref(false);

onMounted(() => {
  // Placeholder — conectar con endpoint cuando esté disponible
  loading.value = false;
});
</script>

<style scoped>
.page-header { margin-bottom: 1.5rem; }
.page-header h1 { margin-bottom: 0.25rem; color: #1e293b; }
.subtitle { color: #6b7280; }
.empty-msg { text-align: center; color: #9ca3af; padding: 2rem; }
</style>
